import mori from 'mori';
import template from './footnotes.html';

export default function() {
  return {
    scope: {},
    templateUrl: template,
    controller: Controller,
    controllerAs: 'vm',
    bindToController: {
      data: '=',
      geomulti: '=',
    },
  };
}

Controller.$inject = ['$scope'];
function Controller($scope) {
  $scope.$watch(
    () => mori.hash(this.data),
    () => {
      this.footnotes = (
        mori.toJs(this.data) || []
      );
    }
  );
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/footnotes/footnotes.js